import { render } from "./PlanetsTable.vue?vue&type=template&id=5b9b6446&scoped=true"
import script from "./PlanetsTable.vue?vue&type=script&lang=js"
export * from "./PlanetsTable.vue?vue&type=script&lang=js"

import "./PlanetsTable.vue?vue&type=style&index=0&id=5b9b6446&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2623155984/src/jamakkol-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9b6446"]])

export default __exports__